import React, { useState } from 'react';

const toursData = [
  {
    id: 1,
    image: '/images/aura-list4.webp',
    title: ' Aura',
    taxiDoors: 4,
    passengers: 4,
    luggageCarry: 2,
    airCondition: 'Yes',
    gpsNavigation: 'Yes',
    link: '/booking',
  },
  {
    id: 2,
    image: '/images/ourfleet/11.jpg',
    title: 'Ertiga',
    taxiDoors: 4,
    passengers: 6,
    luggageCarry: 2,
    airCondition: 'Yes',
    gpsNavigation: 'Yes',
    link: '/booking',
  },
  {
    id: 3,
    image: '/images/innova-list3.webp',
    title: 'Innova Crysta',
    taxiDoors: 4,
    passengers: 6,
    luggageCarry: 2,
    airCondition: 'Yes',
    gpsNavigation: 'Yes',
    link: '/booking',
  },
  {
    id: 3,
    image: '/images/Kia-Carens.webp',
    title: 'Kia Carence',
    taxiDoors: 4,
    passengers: 6,
    luggageCarry: 2,
    airCondition: 'Yes',
    gpsNavigation: 'Yes',
    link: '/booking',
  },
];

const TourBlock = ({ tour }) => {
  return (
    <div className="col-lg-3 col-md-6 col-sm-12 tours-block">
      <div className="tours-block-one">
        <div className="inner-box">
          <div className="image-box">
            <figure className="image"><img src={tour.image} alt={tour.title} /></figure>
          </div>
          <div className="lower-content lower-contentt">
            <h4 className='text-center'><a href={tour.link}>{tour.title}</a></h4>
            <div className="details">
              <div className="detail-item">
                <strong>Taxi Doors:</strong> {tour.taxiDoors}
              </div>
              <div className="detail-item">
                <strong>Passengers:</strong> {tour.passengers}
              </div>
              <div className="detail-item">
                <strong>Luggage Carry:</strong> {tour.luggageCarry}
              </div>
              <div className="detail-item">
                <strong>Air Condition:</strong> {tour.airCondition}
              </div>
              <div className="detail-item">
                <strong>GPS Navigation:</strong> {tour.gpsNavigation}
              </div>
            </div>
            
         <div className='text-center'>
         <a className='th-btn text-white' href={tour.link}>Book Now</a>
         </div>

          </div>
        </div>
      </div>
    </div>
  );
}

const ToursSection = () => {
  const [activeTab] = useState('#tab-1');

  return (
    <section className="tours-section py-2">
      <div className="pattern-layer" style={{ backgroundImage: 'url(/images/shape/shape-2.png)' }}></div>
      <div className="auto-container">
        <div className="tabs-box">
          <div className="upper-box mb_60">
            <div className="sec-title">
              <span className="sub-title">Available Cabs</span>
              <h2>Our Featured Cabs</h2>
            </div>
          </div>
          <div className="tabs-content">
            <div className={`tab ${activeTab === '#tab-1' ? 'active-tab' : ''}`} id="tab-1">
              <div className="row clearfix justify-content-between">
                {toursData.map(tour => (
                  <TourBlock key={tour.id} tour={tour} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ToursSection;
